define("settings/controllers/groups/group/social_profiles/new", ["exports", "@ember/controller", "@ember/object", "@ember/object/computed", "@ember/service", "ember-concurrency-decorators", "@glimmer/tracking"], function (_exports, _controller, _object, _computed, _service, _emberConcurrencyDecorators, _tracking) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11;

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  let NewController = (_dec = (0, _service.inject)('social/facebook-auth'), _dec2 = (0, _service.inject)('social/connect-profiles'), _dec3 = (0, _computed.readOnly)('auth.currentUserModel.hasValidLinkedinUserToken'), (_class = class NewController extends _controller.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "alerts", _descriptor, this);

      _initializerDefineProperty(this, "auth", _descriptor2, this);

      _initializerDefineProperty(this, "facebookAuth", _descriptor3, this);

      _initializerDefineProperty(this, "localStorageManager", _descriptor4, this);

      _initializerDefineProperty(this, "subscriptions", _descriptor5, this);

      _initializerDefineProperty(this, "connectProfiles", _descriptor6, this);

      _defineProperty(this, "queryParams", [{
        showLinkedinSelector: 'show_linkedin_selector'
      }]);

      _defineProperty(this, "path", 'account.groups.group.social_profiles');

      _initializerDefineProperty(this, "hasFacebookSDK", _descriptor7, this);

      _initializerDefineProperty(this, "numberOfFreePlanSocialSets", _descriptor8, this);

      _initializerDefineProperty(this, "selectedSocialProfile", _descriptor9, this);

      _initializerDefineProperty(this, "selectedSocialProfileType", _descriptor10, this);

      _initializerDefineProperty(this, "hasValidLinkedinUserToken", _descriptor11, this);

      _defineProperty(this, "updateShowProfileProperty", (property, value) => {
        this.connectProfiles.updateProperty(property, value);
      });
    }

    get showLinkedinSelector() {
      return this.connectProfiles.showLinkedinSelector;
    }

    set showLinkedinSelector(value) {
      this.connectProfiles.updateProperty('showLinkedinSelector', value);
    }

    get selectedSocialIdentity() {
      return this.connectProfiles.selectedSocialIdentity;
    }

    get showFacebookSelector() {
      return this.connectProfiles.showFacebookSelector;
    }

    get showAddTiktokProfileModal() {
      return this.connectProfiles.showAddTiktokProfileModal;
    }

    get isAdmin() {
      return this.auth.currentUserModel.admin;
    }

    get currentAccount() {
      return this.auth.currentAccount;
    }

    get currentUser() {
      return this.auth.currentUserModel;
    }

    get totalSocialSets() {
      return this.currentAccount.totalSocialSets;
    }

    get isPaid() {
      return this.subscriptions.isPaid;
    }

    get isAccountOwner() {
      return this.auth.currentUserModel.isAccountOwner;
    }

    get subscription() {
      return this.subscriptions.subscription;
    }

    get canAddSocialSets() {
      return this.subscriptions.subscriptionPlan.canAddSocialSets;
    }

    get group() {
      return this.model;
    }

    get hasRemainingSocialSets() {
      return this.socialSetsRemaining > 0;
    }

    get numUsedSocialSets() {
      return this.auth.socialSets.filter(socialSet => socialSet.get('socialProfiles').length > 0).length;
    }

    get socialSetsRemaining() {
      const remaining = (this.totalSocialSets || this.numberOfFreePlanSocialSets) - this.numUsedSocialSets;
      return Math.max(remaining, 0);
    }

    get submitDisabled() {
      return this.selectedSocialProfile === null && this.selectedSocialProfileType === null;
    }

    didInsertElement() {
      this.facebookAuth.loadFacebookSDK().then(() => {
        this.set('hasFacebookSDK', true);
      }, () => {
        this.set('hasFacebookSDK', false);
      });
    }

    selectSocialProfile(socialProfile) {
      this.set('selectedSocialProfile', socialProfile);
    }

    toggleSelect(_ref) {
      let {
        socialIdentity,
        platform
      } = _ref;
      this.connectProfiles.updateProperty('selectedSocialIdentity', socialIdentity);
      this.set('selectedSocialProfileType', platform); // save selected social identity to local storage for LI to access it after oauth redirect

      if (platform === 'li' && socialIdentity.id) {
        this.localStorageManager.setItem('selectedSocialIdentityId', socialIdentity.id);
      }
    }

    async addFacebookProfile(uid, token, scopes) {
      await this.connectProfiles.addFacebookProfile({
        group: this.group,
        uid,
        token,
        scopes,
        path: 'cluster.schedule.calendar'
      });
    }

    async addTiktokProfile(name) {
      await this.connectProfiles.addTiktokProfile({
        name,
        group: this.group,
        path: this.path
      });
    }

    *addLinkedinProfile(id) {
      yield this.connectProfiles.addLinkedinProfile.perform({
        group: this.group,
        id,
        path: this.path
      });
    }

    *addSocialProfile() {
      yield this.connectProfiles.addSocialProfile.perform({
        selectedSocialProfileType: this.selectedSocialProfileType,
        groupId: this.group.id,
        area: 'settings'
      });
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "facebookAuth", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "localStorageManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "connectProfiles", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "hasFacebookSDK", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "numberOfFreePlanSocialSets", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return 1;
    }
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "selectedSocialProfile", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "selectedSocialProfileType", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "hasValidLinkedinUserToken", [_dec3], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "selectSocialProfile", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "selectSocialProfile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleSelect", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleSelect"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addFacebookProfile", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "addFacebookProfile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addTiktokProfile", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "addTiktokProfile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addLinkedinProfile", [_emberConcurrencyDecorators.dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "addLinkedinProfile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addSocialProfile", [_emberConcurrencyDecorators.restartableTask], Object.getOwnPropertyDescriptor(_class.prototype, "addSocialProfile"), _class.prototype)), _class));
  _exports.default = NewController;
});